<template>
	<div class="fixed-bottom-right" :class="{ 'visible': isScrolling }">
		<div class="navss" v-for="(item,index) in navs" :key="index" @click="handleClick(item.url,index)">
			<div style="position: absolute; height: 6px; width: 6px; background-color: white; border-radius: 100%;left: 6px;top: 50%;transform: translateY(-50%);">
			</div>
			{{item.name}}
			<div style="position: absolute; height: 6px; width: 6px; background-color: white; border-radius: 100%;right: 6px;top: 50%;transform: translateY(-50%);">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "fixedBottomRight",
		data() {
			return {
				navs: [{
						name: "官网首页",
						url: "index"
					}, {
						name: "集团介绍",
						url: "introduce"
					},
					{
						name: "经营业务",
						url: "business"
					},
					{
						name: "集采中心",
						url: "cooperation"
					},
					{
						name: "新闻动态",
						url: "journalism"
					},
					{
						name: "联系我们",
						url: "contactUs"
					},
					{
						name: "在线留言",
						url: "message"
					}
				],
				isScrolling: false
			}
		},
		mounted() {
			try {
				window.addEventListener("scroll", this.onScroll); // 在挂载后监听滚动事件
				var route = this.$route.path.replace('/', '');
				var index = -1;
				for (var i = 0; i < this.navs.length; i++) {
					if (route === this.navs[i].url) {
						index = i;
						break;
					}
				}
				this.navs.splice(index, 1);
			} catch (e) {
				alert('异常')
			}
		},
		beforeDestroy() {
			try {
				window.removeEventListener("scroll", this.onScroll); // 在销毁前移除滚动事件
			} catch (e) {
				alert('异常')
			}
		},
		methods: {
			handleClick(url, index) {
				this.$router.push({
					name: url
				})
			},
			onScroll() {
				clearTimeout(this.timer)
				this.isScrolling = true
				this.timer = setTimeout(() => {
					this.isScrolling = false
				}, 2000)
			}
		}
	}
</script>

<style>
	.fixed-bottom-right {
		position: fixed;
		bottom: 90px;
		right: 0;
		opacity: 0;
		transform: translateY(100%);
		transition: all 0.5s ease-in-out;
		z-index: 9999;
	}

	.navss {
		background-color: #840000;
		border-radius: 50px;
		margin-top: 8px;
		margin-bottom: 8px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		width: 100px;
		border: 0.5px solid #840000;
		color: #fff;
		position: relative;
	}


	.visible {
		opacity: 1;
		transform: translateY(0);
	}
</style>


// WEBPACK FOOTER //
// src/assembly/fixedBottomRight.vue